import React from "react";
import { FormattedMessage } from "react-intl";
import { sendSupport } from "../api/supportApi";
import { OPEN_SUPPORT, CLOSE_SUPPORT } from "../constants/ActionTypes";
import { showNotification } from "./notificationsActions";
import { useToken } from "./recaptchaActions";

export const openSupportWindow = () => ({
  type: OPEN_SUPPORT
});

export const closeSupportWindow = () => ({
  type: CLOSE_SUPPORT
});

export const sendSupportRequest = ({
  supportRequest,
  userEmail,
  grecaptchaToken
}) => async dispatch => {
  try {
    await sendSupport({
      supportRequest,
      userEmail,
      grecaptchaToken
    });

    dispatch(showNotification({
      message: (
        <FormattedMessage
          id="supportRequestSuccess"
          defaultMessage="Your request was sent successfully."
        />
      ),
      notificationType: "info",
      dismissDelay: 3000
    }));
    dispatch(closeSupportWindow());
    return true;

  } catch (e) {
    dispatch(showNotification({
      message: (
        <FormattedMessage
          id="supportRequestFailed"
          defaultMessage="Unable to send your request. Please try again."
        />
      ),
      notificationType: "error",
      dismissDelay: 3000
    }));
    return false;
  } finally {
    // Invalidate token afterwards, regardless of response
    dispatch(useToken());
  }
};
